import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { ProductSummaryState, ProductSummaryStore } from './product-summary.store';

@Injectable({ providedIn: 'root' })
export class ProductSummaryQuery extends QueryEntity<ProductSummaryState> {
  constructor(store: ProductSummaryStore) {
    super(store);
  }
}
